import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  templateSelectedIds: [],
  templateTreeData: [],
  templateAppliedData: [],
  templateSearchQuery: "",
  templateExpandedItems: [],
};

const templateTreeSlice = createSlice({
  name: "templateTree",
  initialState,
  reducers: {
    setTemplateSelectedIds: (state, action) => {
      state.templateSelectedIds = action.payload;
    },
    setTemplateTreeData: (state, action) => {
      state.templateTreeData = action.payload;
    },
    setTemplateAppliedData: (state, action) => {
      state.templateAppliedData = action.payload;
    },
    setTemplateSearchQuery: (state, action) => {
      state.templateSearchQuery = action.payload;
    },
    resetTemplateSelection: (state) => {
      state.templateSelectedIds = [];
      state.templateAppliedData = [];
    },
    setTemplateExpandedItems(state, action) {
      state.templateExpandedItems = action.payload;
    },
  },
});

export const {
  setTemplateSelectedIds,
  setTemplateTreeData,
  setTemplateAppliedData,
  setTemplateSearchQuery,
  resetTemplateSelection,
  setTemplateExpandedItems
} = templateTreeSlice.actions;
export default templateTreeSlice.reducer;
